import { Injectable } from '@angular/core';
import { NullLocalStorage } from './null-local-storage';
import { IStorage } from './storage.interface';

@Injectable({ providedIn: 'root' })
export class LocalStorage implements IStorage {
  localStorage;

  constructor() {
    this.localStorage = localStorage || new NullLocalStorage();
  }

  setItem(key: string, value: string): undefined {
    try {
      return this.localStorage.setItem(key, value);
    } catch (error) {
      return undefined;
    }
  }

  getItem(...args) {
    return this.localStorage.getItem(...args);
  }

  removeItem(...args) {
    return this.localStorage.removeItem(...args);
  }

  clear(...args) {
    return this.localStorage.clear(...args);
  }
}
